import Swiper from 'swiper';
import { Autoplay, Pagination, A11y, Keyboard } from 'swiper/modules';

export default function initProjects() {
  const areas = document.querySelectorAll('.aviatrix-block--projects .projects__media');

  areas.forEach(media => {
    const gallery = media.querySelector('.projects__gallery');
    if (!gallery) return;

    const images = Array.from(gallery.querySelectorAll(':scope > .projects__image'));
    if (images.length < 2) return;

    const slider = document.createElement('div');
    slider.className = 'projects__slider';
    slider.setAttribute('role', 'group');
    slider.setAttribute('aria-roledescription', 'carousel');
    slider.setAttribute('aria-label', gallery.getAttribute('aria-label') || 'Gallery');

    const track = document.createElement('div');
    track.className = 'projects__slider-track';

    images.forEach(image => {
      const slide = document.createElement('div');
      slide.className = 'projects__slide';
      slide.appendChild(image);
      track.appendChild(slide);
    });

    slider.appendChild(track);
    gallery.remove();
    media.insertBefore(slider, media.firstChild);

    const template = media.querySelector('.projects__controls-template');
    let pagination = null;
    let toggle = null;

    if (template && template.content) {
      const controls = template.content.firstElementChild.cloneNode(true);
      slider.appendChild(controls);
      pagination = controls.querySelector('.projects__pagination');
      toggle = controls.querySelector('.projects__playpause');
    }

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const swiper = new Swiper(slider, {
      modules: [Autoplay, Pagination, A11y, Keyboard],
      wrapperClass: 'projects__slider-track',
      slideClass: 'projects__slide',
      slidesPerView: 1,
      loop: true,
      watchSlidesProgress: true,
      keyboard: { enabled: true, onlyInViewport: true },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      a11y: {
        prevSlideMessage: 'Previous image',
        nextSlideMessage: 'Next image',
      },
      pagination: pagination ? {
        el: pagination,
        clickable: true,
        bulletClass: 'projects__bullet',
        bulletActiveClass: 'projects__bullet--active',
      } : false,
    });

    let paused = reduceMotion;
    if (paused) {
      swiper.autoplay.stop();
    }

    slider.addEventListener('focusin', () => {
      if (!paused) swiper.autoplay.pause();
    });

    slider.addEventListener('focusout', event => {
      if (!paused && !slider.contains(event.relatedTarget)) swiper.autoplay.resume();
    });

    if (!toggle) return;

    const setPaused = value => {
      paused = value;
      toggle.classList.toggle('is-paused', value);
      toggle.setAttribute(
        'aria-label',
        value ? toggle.dataset.labelPlay : toggle.dataset.labelPause
      );
    };

    setPaused(paused);

    toggle.addEventListener('click', () => {
      const next = !paused;
      if (next) {
        swiper.autoplay.stop();
      } else {
        swiper.autoplay.start();
      }
      setPaused(next);
    });
  });
}
